export default "__VITE_ASSET__CRLj7RQ0__"